module.exports = __webpack_public_path__ + "img/doggy-package-2.small.715c4adc.png";